import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import { PageActions } from './page.actions';
import { Page } from 'www-cms';

export interface PageStateModel {
  page: Page | null;
}

const defaults = {
  page: null,
};

@State<PageStateModel>({
  name: 'page',
  defaults,
})
@Injectable()
export class PageState {
  @Action(PageActions.SetPage)
  setPage(
    { getState, setState }: StateContext<PageStateModel>,
    { payload }: PageActions.SetPage
  ) {
    const state = getState();
    setState({ ...state, page: payload });
  }
}
